<template>
<div>
  <div class="el-form-item title">
    <label class="el-form-item__label">{{$t('APP-FIELD-0139')}}</label>
  </div>
  <ul class="more-contact-row" @click="toggle">
    <li><img src="@/assets/icon_contactinfo_email@2x.png" /></li>
    <li><img src="@/assets/icon_contactinfo_mobile@2x.png" /></li>
    <li><img src="@/assets/icon_contactinfo_phone@2x.png" /></li>
    <li><i :class="arrow" /></li>
  </ul>

  </div>
</template>

<script>
const arrow = {
  up: 'el-icon-arrow-up',
  down: 'el-icon-arrow-down',
}

  export default {
    name: "MoreContactInfo",
    model: {
      prop: 'toggleContact',
      event: 'change'
    },  
    props: [ 'toggleContact' ],

    data() {

     return {
        arrow: arrow.down
     }
    },

    watch: {
      toggleContact(newValue) {
        this.arrow = newValue ? arrow.up : arrow.down
      }
    },

    methods: {
      toggle () {
        // this.arrow = this.arrow === arrow.up ? arrow.down : arrow.up;
        this.$emit('change', !this.$props.toggleContact);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .el-form-item.title {
    margin-bottom: 0px;
  }
  .more-contact-row {
    li{
      display: inline-block;
      margin-right: 20px;
      vertical-align: middle;
      cursor: pointer;
    }
    img {
      width: 50px;
      height: 50px;
    }

    i {
      margin-left: 10px;
      font-size: 24px;
      font-weight: bold;
      color: #0487CE;
    }
  }
</style>